import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Organization } from 'src/app/modules/organization-admin/models/organization';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { OrganizationAdminService } from 'src/app/modules/organization-admin/services/organization-admin.service';
import { WfhService } from '../../services/wfh.service';
import * as moment from 'moment';
import { Users } from 'src/app/modules/users/models/users';
import { UsersService } from 'src/app/modules/users/services/users.service';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-wfh-create',
  templateUrl: './wfh-create.component.html',
  styleUrls: ['./wfh-create.component.css']
})
export class WfhCreateComponent implements OnInit {
  @ViewChild('myForm', { static: false }) myForm: NgForm;

  public wfhForm: FormGroup;
  public organizations: Organization;
  public user_details: any = this.authservice.getUserDetails();

  public hasRole: string = this.authservice.hasRole();
  public orgId: string = this.authservice.getOrgId();

  public isShowAlert: boolean = false;
  public isShowOrganization: boolean = false;
  public isShowUsers: boolean = true;

  public fromMaxDate: Date;
  public fromMinDate: Date;
  public toMaxDate: Date;
  public toMinDate: Date;
  public searchUserNameCtrl = new FormControl('', Validators.required);

  users: any[] = [];  // Initialize as an empty array to avoid undefined error
  applied_to: any[] = [];
  USERS_LIST: any;
  usersReport: any;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private authservice: AuthenticationService,
    private organizationService: OrganizationAdminService,
    private wfhService: WfhService,
    private userService: UsersService
  ) {}

  ngOnInit(): void {
    this.createwfhForm();
    this.checkAuthenticationType();
    this.searchUserName();
    setTimeout(() => {
      console.log('Calling getReportingList after init');
      this.getReportingList(); // Ensure reporting list is fetched on init
    });
  }

  getUsers(orgId: string = undefined): void {
    let filterParams = {};
    filterParams["sort"] = "-id";

    if (orgId !== undefined) {
      filterParams['filter[org_id]'] = orgId;
    }

    let searchParams = this.searchUserNameCtrl.value;
    if (searchParams !== '' && searchParams.length >= 3) {
      filterParams['filter[name][like]'] = searchParams.trim();
    }

    this.userService.getUsersList(filterParams).subscribe((res: any) => {
      if (res && res.body) {
        this.users = res.body;  // Assign data to users only when it is not undefined
        if (this.USERS_LIST === undefined || this.USERS_LIST.length === 0) {
          this.USERS_LIST = res.body;
        }
        this.checkAuthenticationType();
      } else {
        console.log('No users found');
      }
    }, (err) => {
      console.error('Error fetching users:', err);
    });
  }

  searchUserName(): void {
    this.searchUserNameCtrl.valueChanges
      .pipe(delay(300))
      .subscribe((val) => {
        this.wfhForm.patchValue({
          user_id: this.searchUserNameCtrl.value ? this.searchUserNameCtrl.value.id : '',
        });
        if (
          this.searchUserNameCtrl.value.id !== undefined &&
          this.searchUserNameCtrl.value.id !== ''
        ) {
          console.log('Fetching reporting users for user ID: ', this.searchUserNameCtrl.value.id);
          this.getReportedToUsers(this.searchUserNameCtrl.value.id); // Get reporting users when user is selected
        }
        this.getUsers(this.orgId);
        this.getReportingList(this.searchUserNameCtrl.value.id);
      });
  }

  getReportedToUsers(user_id: number | string): void {
    if (!this.users || this.users.length === 0) {
      console.log('Users list is empty. Please wait for data to be loaded.');
      return; // Don't proceed if the users list is not yet available
    }

    const selectedUser: Users = this.users.find((d) => d.id === user_id);

    if (!selectedUser || !selectedUser.reporting_to || selectedUser.reporting_to.length === 0) {
      this.applied_to = []; // Clear applied_to if no reporting users
      return;
    }

    const reportedToUserIds = selectedUser.reporting_to.map((report: any) => report.reporting_to);
    const uniqueReportedToUserIds = Array.from(new Set(reportedToUserIds));

    this.applied_to = uniqueReportedToUserIds
      .map((userId: number | string) => {
        return this.USERS_LIST.find((user) => user.id === userId);
      })
      .filter((user) => user); // Filter out undefined values

    if (this.applied_to.length === 0) {
      this.applied_to = [selectedUser]; // Fallback to the selected user
    }

    this.wfhForm.get('applied_to').setValidators([Validators.required]);
    this.wfhForm.get('applied_to').updateValueAndValidity();
  }

  checkAuthenticationType(): void {
    if (this.hasRole === '1') {
      setTimeout(() => {
        this.getOrganizations();
      });
      this.isShowOrganization = true;
      this.orgId = '';
      this.wfhForm.get('org_id').setValidators([Validators.required]);
      this.wfhForm.get('org_id').updateValueAndValidity();
    } else {
      this.orgId = this.authservice.getOrgId();
    }

    this.isShowUsers = true;
    let user_id = this.user_details.user_id || null;
    this.wfhForm.get('user_id').patchValue(user_id);
    this.wfhForm.get('org_id').patchValue(this.orgId);
    this.getReportedToUsers(user_id);
  }

  getOrganizations(): void {
    this.organizationService.getOrganizations().subscribe((res: any) => {
      this.organizations = res.body;
    });
  }

  onFromDateChange(event): void {
    this.toMinDate = event.target.value;
    this.leaveDays();
  }

  onToDateChange(event): void {
    this.fromMaxDate = event.target.value;
    this.leaveDays();
  }

  createwfhForm(): void {
    this.wfhForm = this.fb.group({
      org_id: [this.orgId],
      user_id: [''],
      leave_from: ['', [Validators.required]],
      leave_to: ['', [Validators.required]],
      leave_days: ['', [Validators.required]],
      applied_to: ['', [Validators.required]],
      wfh_reason: [''],
    });
  }

  get wfhFormValidate() {
    return this.wfhForm.controls;
  }

  DifferenceBitWeenTwoDays(from_date: any, to_date: any): number {
    let fromDate = moment(from_date, 'DD/MM/YYYY');
    let toDate = moment(to_date, 'DD/MM/YYYY');
    return fromDate.diff(toDate, 'days');
  }

  leaveDays(): void {
    let leave_from = this.wfhForm.value.leave_from;
    let leave_to = this.wfhForm.value.leave_to;

    if (leave_from !== '' && leave_to !== '') {
      let diffDays = this.DifferenceBitWeenTwoDays(
        this.wfhForm.value.leave_from,
        this.wfhForm.value.leave_to
      );
      let days = Math.abs(diffDays) + 1;
      if (days === 0) {
        alert('Invalid! check your dates or sessions');
        return;
      }
      this.wfhForm.get('leave_days').setValue(days);
      this.wfhForm.get('leave_days').disable({ onlySelf: true });
      this.wfhForm.get('leave_days').updateValueAndValidity();
    }
  }

  wfhFormSubmit(): void {
    if (this.wfhForm.invalid) {
      return;
    }
    this.wfhForm.patchValue({
      leave_from: moment(this.wfhForm.value.leave_from).format('YYYY-MM-DD'),
      leave_to: moment(this.wfhForm.value.leave_to).format('YYYY-MM-DD'),
    });
    this.wfhForm.get('leave_days').enable();
    this.wfhForm.get('leave_days').updateValueAndValidity();

    const formData = {
      user_id: this.wfhForm.value.user_id, // The user who is logged in
      leave_days: this.wfhForm.value.leave_days, // The calculated leave days
      leave_from: this.wfhForm.value.leave_from,
      leave_to: this.wfhForm.value.leave_to,
      wfh_reason: this.wfhForm.value.wfh_reason,
      applied_to: this.wfhForm.value.applied_to,
      org_id: this.wfhForm.value.org_id,
    };

    this.wfhService.createWfh(this.wfhForm.value).subscribe((res) => {
      this.wfhForm.reset();
      this.myForm.resetForm();
      this.isShowAlert = true;
      this.closeAlertMessage();
      this.createwfhForm();
      this.checkAuthenticationType();
    });
  }

  cancel(): void {
    this.dialog.closeAll();
  }

  closeAlertMessage(): void {
    setTimeout(() => {
      this.isShowAlert = false;
    }, 5000);
  }

  getReportingList(userId: string = undefined): void {
    let filterParams = {};
    filterParams['sort'] = '-id';

    if (userId !== undefined) {
      filterParams['filter[user_id]'] = userId;
    }

    this.userService.getReportingList(filterParams).subscribe((res: any) => {
      this.usersReport = res.body;
      console.log('Reporting users:', this.usersReport); // Check if data is received correctly
    });
  }
}
